import { useMemo } from "react";

import useSortState from "components/Filters/useSortState";
import TableSimple from "ds/components/TableSimple";
import useAnalytics from "hooks/useAnalytics";

import { useIdpGroupTableStore } from "./useIdpGroupTableStore";
import { SORT_CONFIG } from "./constants";
import { sortGroups } from "./sort";
import { ManagedUserGroupView } from "../types";
import { IDP_GROUP_TABLE_CELLS } from "./Cells";
import { IdpGroupFilterItemKeys, FILTERS_ORDER_SETTINGS_KEY } from "../constants";

type IdpGroupMappingTableProps = {
  groups: ManagedUserGroupView[];
  loadingContent?: boolean;
};

const IdpGroupMappingTable = ({ groups, loadingContent }: IdpGroupMappingTableProps) => {
  const trackAnalytics = useAnalytics();

  const { sortState } = useSortState();

  const sortedGroups = useMemo(
    () => sortGroups(groups, sortState.sortKey as IdpGroupFilterItemKeys, sortState.sortDirection),
    [groups, sortState.sortKey, sortState.sortDirection]
  );

  return (
    <TableSimple
      data={sortedGroups}
      store={useIdpGroupTableStore}
      loading={loadingContent}
      cellPerColumn={IDP_GROUP_TABLE_CELLS}
      rowsPerPage={groups.length || 10}
      ariaLabel="Identity Provider Group Mapping table"
      hasPagination={false}
      filtersStorageKey={FILTERS_ORDER_SETTINGS_KEY}
      sortConfig={SORT_CONFIG}
      trackAnalytics={trackAnalytics}
    />
  );
};

export default IdpGroupMappingTable;
